// // components/admin/user/CabinetTilesAdmin.jsx
// import { useEffect, useState } from "react";
// import {
//   saveCabinetTiles,
//   subscribeCabinetTiles,
//   uploadContract,
// } from "../../../services/cabinetTilesService";
// import s from "./CabinetTilesAdmin.module.css";

// export default function CabinetTilesAdmin() {
//   const [cfg, setCfg] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [fSale, setFSale] = useState(null);
//   const [fCons, setFCons] = useState(null);
//   const [fDrop, setFDrop] = useState(null);

//   useEffect(() => {
//     const unsub = subscribeCabinetTiles(setCfg);
//     return () => unsub && unsub();
//   }, []);

//   const onSave = async () => {
//     setSaving(true);
//     try {
//       await saveCabinetTiles(cfg);
//       if (fSale) await uploadContract("sale", fSale);
//       if (fCons) await uploadContract("consignment", fCons);
//       if (fDrop) await uploadContract("dropshipping", fDrop);
//       setFSale(null);
//       setFCons(null);
//       setFDrop(null);
//       alert("Збережено");
//     } catch (e) {
//       console.error(e);
//       alert("Помилка збереження");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const set = (path, value) => {
//     setCfg((prev) => {
//       const next = structuredClone(prev || {});
//       const keys = path.split(".");
//       let p = next;
//       for (let i = 0; i < keys.length - 1; i++) {
//         p[keys[i]] = p[keys[i]] || {};
//         p = p[keys[i]];
//       }
//       p[keys.at(-1)] = value;
//       return next;
//     });
//   };

//   return (
//     <div className={s.page}>
//       <h1 className={s.heading}>Кабінет партнера — плашки (адмін)</h1>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Плашка 1 — інформаційна (оплата)</div>
//         <div className={s.row}>
//           <input
//             className={s.input}
//             placeholder="Текст для Рахунку"
//             value={cfg?.tile1?.invoiceText || ""}
//             onChange={(e) => set("tile1.invoiceText", e.target.value)}
//           />
//           <input
//             className={s.input}
//             placeholder="Текст для Еквайрингу"
//             value={cfg?.tile1?.acquiringText || ""}
//             onChange={(e) => set("tile1.acquiringText", e.target.value)}
//           />
//         </div>
//       </div>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Плашка 2 — Заявка на зміну способу</div>
//         <div className={s.row}>
//           <input
//             className={s.input}
//             placeholder="Кнопка при поточному=Рахунок (показати Еквайринг)"
//             value={cfg?.tile2?.invoiceCta || ""}
//             onChange={(e) => set("tile2.invoiceCta", e.target.value)}
//           />
//           <input
//             className={s.input}
//             placeholder="Кнопка при поточному=Еквайринг (показати Рахунок)"
//             value={cfg?.tile2?.acquiringCta || ""}
//             onChange={(e) => set("tile2.acquiringCta", e.target.value)}
//           />
//         </div>
//         <input
//           className={s.input}
//           placeholder="@lesia_username"
//           value={cfg?.tile2?.telegram || ""}
//           onChange={(e) => set("tile2.telegram", e.target.value)}
//         />
//         <textarea
//           className={s.textarea}
//           rows={4}
//           placeholder="Шаблон повідомлення в TG (змінні: {{name}}, {{current}}, {{desired}})"
//           value={cfg?.tile2?.template || ""}
//           onChange={(e) => set("tile2.template", e.target.value)}
//         />
//       </div>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Плашка 3 — Порекомендуйте книгу</div>
//         <input
//           className={s.input}
//           placeholder="Текст кнопки"
//           value={cfg?.tile3?.label || ""}
//           onChange={(e) => set("tile3.label", e.target.value)}
//         />
//         <div className={s.row}>
//           <input
//             className={s.input}
//             placeholder="@lesia_username"
//             value={cfg?.tile3?.telegram || ""}
//             onChange={(e) => set("tile3.telegram", e.target.value)}
//           />
//           <input
//             className={s.input}
//             placeholder="Префіл для TG"
//             value={cfg?.tile3?.template || ""}
//             onChange={(e) => set("tile3.template", e.target.value)}
//           />
//         </div>
//       </div>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Плашка 4 — Скрипти продаж (YouTube)</div>
//         <div className={s.row}>
//           <input
//             className={s.input}
//             placeholder="Текст кнопки"
//             value={cfg?.tile4?.label || ""}
//             onChange={(e) => set("tile4.label", e.target.value)}
//           />
//           <input
//             className={s.input}
//             placeholder="Посилання на YouTube"
//             value={cfg?.tile4?.url || ""}
//             onChange={(e) => set("tile4.url", e.target.value)}
//           />
//         </div>
//       </div>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Плашка 5 — Інформаційна</div>
//         <input
//           className={s.input}
//           placeholder="Заголовок"
//           value={cfg?.tile5?.title || ""}
//           onChange={(e) => set("tile5.title", e.target.value)}
//         />
//         <textarea
//           className={s.textarea}
//           rows={4}
//           placeholder="Текст"
//           value={cfg?.tile5?.text || ""}
//           onChange={(e) => set("tile5.text", e.target.value)}
//         />
//         <div className={s.row}>
//           <input
//             className={s.input}
//             placeholder="Текст кнопки"
//             value={cfg?.tile5?.ctaText || ""}
//             onChange={(e) => set("tile5.ctaText", e.target.value)}
//           />
//           <input
//             className={s.input}
//             placeholder="URL кнопки"
//             value={cfg?.tile5?.ctaUrl || ""}
//             onChange={(e) => set("tile5.ctaUrl", e.target.value)}
//           />
//         </div>
//       </div>

//       <div className={s.card}>
//         <div className={s.cardTitle}>Договори (PDF)</div>
//         <div className={s.row}>
//           <div className={s.col}>
//             <div className={s.label}>Продаж</div>
//             {cfg?.contracts?.sale?.fileName && (
//               <div className={s.meta}>{cfg.contracts.sale.fileName}</div>
//             )}
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={(e) => setFSale(e.target.files?.[0] || null)}
//             />
//           </div>
//           <div className={s.col}>
//             <div className={s.label}>Реалізація</div>
//             {cfg?.contracts?.consignment?.fileName && (
//               <div className={s.meta}>{cfg.contracts.consignment.fileName}</div>
//             )}
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={(e) => setFCons(e.target.files?.[0] || null)}
//             />
//           </div>
//           <div className={s.col}>
//             <div className={s.label}>Дропшипінг</div>
//             {cfg?.contracts?.dropshipping?.fileName && (
//               <div className={s.meta}>
//                 {cfg.contracts.dropshipping.fileName}
//               </div>
//             )}
//             <input
//               type="file"
//               accept="application/pdf"
//               onChange={(e) => setFDrop(e.target.files?.[0] || null)}
//             />
//           </div>
//         </div>
//       </div>

//       <div className={s.footer}>
//         <button className={s.btnPrimary} disabled={saving} onClick={onSave}>
//           {saving ? "Збереження…" : "Зберегти"}
//         </button>
//       </div>
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import {
  saveCabinetTiles,
  subscribeCabinetTiles,
  uploadContract,
} from "../../../services/cabinetTilesService";

export default function CabinetTilesAdmin() {
  const [cfg, setCfg] = useState({});
  const [saving, setSaving] = useState(false);
  const [fSale, setFSale] = useState(null);
  const [fCons, setFCons] = useState(null);
  const [fDrop, setFDrop] = useState(null);

  useEffect(() => {
    const unsub = subscribeCabinetTiles(setCfg);
    return () => unsub && unsub();
  }, []);

  const onSave = async () => {
    setSaving(true);
    try {
      await saveCabinetTiles(cfg);
      if (fSale) await uploadContract("sale", fSale);
      if (fCons) await uploadContract("consignment", fCons);
      if (fDrop) await uploadContract("dropshipping", fDrop);
      setFSale(null);
      setFCons(null);
      setFDrop(null);
      alert("Збережено");
    } catch (e) {
      console.error(e);
      alert("Помилка збереження");
    } finally {
      setSaving(false);
    }
  };

  const set = (path, value) => {
    setCfg((prev) => {
      const next = structuredClone(prev || {});
      const keys = path.split(".");
      let p = next;
      for (let i = 0; i < keys.length - 1; i++) {
        p[keys[i]] = p[keys[i]] || {};
        p = p[keys[i]];
      }
      p[keys.at(-1)] = value;
      return next;
    });
  };

  return (
    <div className="ua-page">
      <style>{CSS}</style>

      <h1 className="ua-heading">Кабінет партнера — плашки (адмін)</h1>

      {/* Tile 1 */}
      <div className="ua-card">
        <div className="ua-cardTitle">Плашка 1 — інформаційна (оплата)</div>
        <div className="ua-row">
          <label className="ua-field">
            <span>Текст для Рахунку</span>
            <input
              className="ua-input"
              placeholder="Текст для Рахунку"
              value={cfg?.tile1?.invoiceText || ""}
              onChange={(e) => set("tile1.invoiceText", e.target.value)}
            />
          </label>
          <label className="ua-field">
            <span>Текст для Еквайрингу</span>
            <input
              className="ua-input"
              placeholder="Текст для Еквайрингу"
              value={cfg?.tile1?.acquiringText || ""}
              onChange={(e) => set("tile1.acquiringText", e.target.value)}
            />
          </label>
        </div>
      </div>

      {/* Tile 2 */}
      <div className="ua-card">
        <div className="ua-cardTitle">Плашка 2 — Заявка на зміну способу</div>
        <div className="ua-row">
          <label className="ua-field">
            <span>Кнопка (коли поточний = Рахунок)</span>
            <input
              className="ua-input"
              placeholder="Показати Еквайринг"
              value={cfg?.tile2?.invoiceCta || ""}
              onChange={(e) => set("tile2.invoiceCta", e.target.value)}
            />
          </label>
          <label className="ua-field">
            <span>Кнопка (коли поточний = Еквайринг)</span>
            <input
              className="ua-input"
              placeholder="Показати Рахунок"
              value={cfg?.tile2?.acquiringCta || ""}
              onChange={(e) => set("tile2.acquiringCta", e.target.value)}
            />
          </label>
        </div>

        <label className="ua-field">
          <span>Контакт у Telegram</span>
          <input
            className="ua-input"
            placeholder="@lesia_username"
            value={cfg?.tile2?.telegram || ""}
            onChange={(e) => set("tile2.telegram", e.target.value)}
          />
        </label>

        <label className="ua-field">
          <span>Шаблон повідомлення в TG</span>
          <textarea
            className="ua-textarea"
            rows={4}
            placeholder="Використовуйте змінні: {{name}}, {{current}}, {{desired}}"
            value={cfg?.tile2?.template || ""}
            onChange={(e) => set("tile2.template", e.target.value)}
          />
        </label>
      </div>

      {/* Tile 3 */}
      <div className="ua-card">
        <div className="ua-cardTitle">Плашка 3 — Порекомендуйте книгу</div>

        <label className="ua-field">
          <span>Текст кнопки</span>
          <input
            className="ua-input"
            placeholder="Текст кнопки"
            value={cfg?.tile3?.label || ""}
            onChange={(e) => set("tile3.label", e.target.value)}
          />
        </label>

        <div className="ua-row">
          <label className="ua-field">
            <span>Telegram</span>
            <input
              className="ua-input"
              placeholder="@lesia_username"
              value={cfg?.tile3?.telegram || ""}
              onChange={(e) => set("tile3.telegram", e.target.value)}
            />
          </label>
          <label className="ua-field">
            <span>Префіл для TG</span>
            <input
              className="ua-input"
              placeholder="Префіл (текст)"
              value={cfg?.tile3?.template || ""}
              onChange={(e) => set("tile3.template", e.target.value)}
            />
          </label>
        </div>
      </div>

      {/* Tile 4 */}
      <div className="ua-card">
        <div className="ua-cardTitle">Плашка 4 — Скрипти продаж (YouTube)</div>
        <div className="ua-row">
          <label className="ua-field">
            <span>Текст кнопки</span>
            <input
              className="ua-input"
              placeholder="Текст кнопки"
              value={cfg?.tile4?.label || ""}
              onChange={(e) => set("tile4.label", e.target.value)}
            />
          </label>
          <label className="ua-field">
            <span>Посилання на YouTube</span>
            <input
              className="ua-input"
              placeholder="https://…"
              value={cfg?.tile4?.url || ""}
              onChange={(e) => set("tile4.url", e.target.value)}
            />
          </label>
        </div>
      </div>

      {/* Tile 5 */}
      <div className="ua-card">
        <div className="ua-cardTitle">Плашка 5 — Інформаційна</div>

        <label className="ua-field">
          <span>Заголовок</span>
          <input
            className="ua-input"
            placeholder="Заголовок"
            value={cfg?.tile5?.title || ""}
            onChange={(e) => set("tile5.title", e.target.value)}
          />
        </label>

        <label className="ua-field">
          <span>Текст</span>
          <textarea
            className="ua-textarea"
            rows={4}
            placeholder="Текст…"
            value={cfg?.tile5?.text || ""}
            onChange={(e) => set("tile5.text", e.target.value)}
          />
        </label>

        <div className="ua-row">
          <label className="ua-field">
            <span>Текст кнопки</span>
            <input
              className="ua-input"
              placeholder="CTA"
              value={cfg?.tile5?.ctaText || ""}
              onChange={(e) => set("tile5.ctaText", e.target.value)}
            />
          </label>
          <label className="ua-field">
            <span>URL кнопки</span>
            <input
              className="ua-input"
              placeholder="https://…"
              value={cfg?.tile5?.ctaUrl || ""}
              onChange={(e) => set("tile5.ctaUrl", e.target.value)}
            />
          </label>
        </div>
      </div>

      {/* Contracts */}
      <div className="ua-card">
        <div className="ua-cardTitle">Договори (PDF)</div>

        <div className="ua-row">
          <div className="ua-col">
            <div className="ua-label">Продаж</div>
            {cfg?.contracts?.sale?.fileName && (
              <div className="ua-meta">{cfg.contracts.sale.fileName}</div>
            )}
            <label className="ua-fileBtn">
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setFSale(e.target.files?.[0] || null)}
              />
              Обрати файл
            </label>
          </div>

          <div className="ua-col">
            <div className="ua-label">Реалізація</div>
            {cfg?.contracts?.consignment?.fileName && (
              <div className="ua-meta">
                {cfg.contracts.consignment.fileName}
              </div>
            )}
            <label className="ua-fileBtn">
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setFCons(e.target.files?.[0] || null)}
              />
              Обрати файл
            </label>
          </div>

          <div className="ua-col">
            <div className="ua-label">Дропшипінг</div>
            {cfg?.contracts?.dropshipping?.fileName && (
              <div className="ua-meta">
                {cfg.contracts.dropshipping.fileName}
              </div>
            )}
            <label className="ua-fileBtn">
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setFDrop(e.target.files?.[0] || null)}
              />
              Обрати файл
            </label>
          </div>
        </div>
      </div>

      <div className="ua-footer">
        <button className="ua-btnPrimary" disabled={saving} onClick={onSave}>
          {saving ? "Збереження…" : "Зберегти"}
        </button>
      </div>
    </div>
  );
}

/* ===== CSS-in-JSX ===== */
const CSS = `
:root{
  --bg:#f7f8fc;          /* світлий фон адмінки */
  --card:#ffffff;        /* картки */
  --muted:#667085;       /* допоміжний текст */
  --text:#0f172a;        /* основний текст */
  --accent:#2563eb;      /* акцент (кнопки) */
  --accent-2:#16a34a;    /* зелені бейджі */
  --border:#e5e7eb;      /* бордери */
  --danger:#dc2626;
  --shadow:0 8px 24px rgba(2,6,23,.08);
  --radius:14px;
  --gap:16px;
  --gap-lg:20px;
}

*{box-sizing:border-box}
.ua-page{
  color:var(--text);
  background:var(--bg);
  min-height:100%;
  padding:28px 22px 40px;
}
.ua-heading{
  font-size:26px;
  margin:0 0 18px;
  letter-spacing:.2px;
  font-weight:700;
}

.ua-card{
  background:var(--card);
  border:1px solid var(--border);
  border-radius:var(--radius);
  padding:18px;
  margin:14px 0;
  box-shadow:var(--shadow);
}
.ua-cardTitle{
  font-weight:700;
  margin-bottom:14px;
  font-size:16px;
  letter-spacing:.2px;
}

.ua-row{
  display:grid;
  grid-template-columns:repeat(2, minmax(0,1fr));
  gap:var(--gap);
}
@media (max-width:920px){
  .ua-row{ grid-template-columns:1fr; }
}
.ua-col{ display:flex; flex-direction:column; gap:10px; }

.ua-field{ display:flex; flex-direction:column; gap:8px; }
.ua-field > span{
  font-size:12px;
  text-transform:uppercase;
  letter-spacing:.6px;
  color:var(--muted);
}

.ua-input, .ua-textarea, .ua-inputN {
  width:100%;
  background:#fff;
  color:var(--text);
  border:1px solid var(--border);
  border-radius:10px;
  padding:12px 14px;
  outline:none;
  transition:border-color .2s, box-shadow .2s;
}
.ua-inputN{ max-width:180px; }
.ua-input:focus, .ua-textarea:focus, .ua-inputN:focus{
  border-color:var(--accent);
  box-shadow:0 0 0 3px rgba(37,99,235,.18);
}
.ua-textarea{ resize:vertical; line-height:1.5; }

.ua-label{ font-size:12px; color:var(--muted); margin-bottom:4px; }
.ua-meta{
  font-size:12px; color:#475467; background:#fafafa; border:1px dashed var(--border);
  border-radius:8px; padding:6px 8px; display:inline-block; max-width:100%;
  overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}

.ua-fileBtn{
  display:inline-flex; align-items:center; gap:10px;
  background:#fff; color:var(--text);
  border:1px dashed var(--border);
  border-radius:10px; padding:10px 12px; cursor:pointer;
  transition:all .2s ease;
  width:fit-content;
}
.ua-fileBtn:hover{ border-color:var(--accent); background:#f8fafc; }
.ua-fileBtn input{ display:none; }

.ua-footer{
  position:sticky; bottom:0; padding-top:12px; margin-top:18px;
  background:linear-gradient(180deg, rgba(247,248,252,0) 0%, var(--bg) 38%);
  display:flex; justify-content:flex-end;
}
.ua-btnPrimary{
  appearance:none; border:0; border-radius:12px;
  padding:12px 18px; font-weight:700; letter-spacing:.2px;
  color:white; background:var(--accent);
  box-shadow:0 10px 18px rgba(37,99,235,.18);
  cursor:pointer; transition:transform .06s ease, filter .15s ease, opacity .2s;
}
.ua-btnPrimary:hover{ filter:brightness(1.05); }
.ua-btnPrimary:active{ transform:translateY(1px); }
.ua-btnPrimary:disabled{ opacity:.6; cursor:not-allowed; }
`;
